import store from '@/store/index'
import api from '@/api/api.js'
import { checkConfig, checkSend } from '@/utils/viewConfig'
import { formatLocation } from './util'
import { getLocationA, initMap } from '@/utils/getUserLocation'
let { getWxInfo } = api

export default function getInitInfo(name) {
  let obj = JSON.parse(localStorage.getItem('userInfo')) || {}
  if (!obj.openId) {
    store.commit('set_routerViewShow', true)
    store.commit('hideLoading')
    // if (name === 'goFastMail' || name === 'allServicePoint') {
    //   getLocation()
    // }
    return
  }
  let wechatCode = obj.partner
  let url = window.location.href.split('#')[0]
  let params = {
    wechatCode: wechatCode,
    url: url
  }
  let noConfig = checkConfig(url) // 检测当前页面是否不需要wx.config
  let noSend = checkSend(url) // 当前页面是否属于寄件内容
  if (noConfig || (store.state.getLocationNum !== 1 && noSend)) {
    store.commit('set_routerViewShow', true)
    return
  }
  getWxInfo(params).then(res => {
    if (res) {
      obj = Object.assign(obj, { appId: res.appId })
      localStorage.setItem('userInfo', JSON.stringify(obj))
      initWx(res, name)
    }
  })
}
export function initWx(info, name) {
  global.wx.config({
    debug: false,
    appId: info.appId,
    timestamp: info.timestamp,
    nonceStr: info.nonceStr,
    signature: info.signature,
    jsApiList: [
      'chooseWxPay',
      'hideAllNonBaseMenuItem',
      'getLocation',
      'closeWindow'
    ]
  })
  global.wx.ready(function() {
    // global.wx.hideAllNonBaseMenuItem()
    if (
      !window.location.href.split('#')[0].includes('goFastMail') ||
      store.state.getLocationNum !== 1
    ) {
      store.commit('hideLoading')
      store.commit('set_routerViewShow', true)
      return
    }
    if (name === 'goFastMail' || name === 'allServicePoint') {
      if (store.state.getLocationNum === 1) {
        global.wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function(res) {
            let obj = {
              latitude: formatLocation(res.latitude),
              longitude: formatLocation(res.longitude)
            }
            localStorage.setItem('location', JSON.stringify(obj))
            store.commit('set_routerViewShow', true)
            store.commit('set_getLocationNum')
          },
          fail: function() {
            alert('获取定位失败！')
            store.commit('hideLoading')
            store.commit('set_routerViewShow', true)
          }
        })
      } else {
        store.commit('hideLoading')
        store.commit('set_routerViewShow', true)
      }
    }
    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
  })
  global.wx.error(function(res) {
    store.commit('hideLoading')
    store.commit('set_routerViewShow', true)
    alert(res.errMsg)
    alert('微信授权失败')
  })
}
export async function getLocation() {
  let AMap = await initMap()
  let res = await getLocationA(AMap)
  if (res.code === 1) {
    let obj = {
      latitude: formatLocation(res.latitude),
      longitude: formatLocation(res.longitude)
    }
    localStorage.setItem('location', JSON.stringify(obj))
  } else {
    // alert('定位获取失败')
  }
}
